import React, { Component } from "react";
import { Container, Row, Col, Card, CardBody, CardHeader, Table } from "reactstrap";

class PricingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricing: [
        {
          service: "Standard Delivery",
          basePrice: "R250",
          pricePerKm: "R8",
          notes: "Up to 50km distance"
        },
        {
          service: "Express Delivery",
          basePrice: "R450",
          pricePerKm: "R12",
          notes: "Priority handling and routing"
        },
        {
          service: "Short-Term Storage",
          basePrice: "R40/day",
          pricePerKm: "N/A",
          notes: "Climate controlled facilities"
        },
        {
          service: "Medium-Term Storage",
          basePrice: "R35/day",
          pricePerKm: "N/A",
          notes: "Minimum 30-day term"
        },
        {
          service: "Long-Term Storage",
          basePrice: "R30/day",
          pricePerKm: "N/A",
          notes: "Minimum 180-day term"
        }
      ]
    };
  }

  componentDidMount() {
    document.title = "Pricing | QikTruck";
  }

  render() {
    return (
      <React.Fragment>
        
        <section className="section mt-5 pt-4">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10}>
                <Card>
                  <CardHeader>
                    <h4 className="mb-0">Pricing</h4>
                  </CardHeader>
                  <CardBody>
                    <p className="mb-4">Our transparent pricing structure ensures you always know what you're paying for. Volume discounts are available for regular customers.</p>
                    
                    <Table hover responsive className="mt-4">
                      <thead>
                        <tr>
                          <th>Service</th>
                          <th>Base Price</th>
                          <th>Price Per Km</th>
                          <th>Notes</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.pricing.map((item, index) => (
                          <tr key={index}>
                            <td>{item.service}</td>
                            <td>{item.basePrice}</td>
                            <td>{item.pricePerKm}</td>
                            <td>{item.notes}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    
                    <div className="mt-4">
                      <h5>Additional Fees</h5>
                      <ul>
                        <li>After-hours pickup/delivery: R150</li>
                        <li>Weekend service: R200</li>
                        <li>Multiple drop-offs: R100 per additional location</li>
                        <li>Oversized items handling: Price on request</li>
                      </ul>
                    </div>
                    
                    <div className="mt-4">
                      <h5>Volume Discounts</h5>
                      <p>Contact our sales team for customized pricing based on your business volume requirements.</p>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default PricingPage; 